<template>
  <div class="new-group-form-wrapper card">
    <page-header
      title="New Group"
      breadcrumbText="Dashboard >> Settings >> Users and Groups >> New Group"
    />
    <div class="group-details-form-wrapper">
      <div class="form-header">
        <p class="text-secondary-orange font-semibold">Group Details</p>
      </div>
      <div class="group-details__form">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12">
              <div class="group-details__input-wrapper">
                <label for="name" class="label">Group Name</label>
                <input
                  type="text"
                  class="input"
                  id="name"
                  v-model="newGroup.groupName"
                />
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <div class="group-details__input-wrapper">
                <label for="description" class="label">Group Description</label>
                <input
                  type="text"
                  class="input"
                  id="description"
                  v-model="newGroup.groupDescription"
                />
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <div class="group-details__input-wrapper">
                <label for="group-type" class="label">Group Type</label>
                <el-select v-model="newGroup.groupType">
                  <el-option
                    v-for="groupType in groupTypes"
                    :key="groupType"
                    :label="groupType"
                    :value="groupType"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <div class="group-details__input-wrapper">
                <label for="email" class="label">Group Email ID</label>
                <input
                  type="text"
                  class="input"
                  id="email"
                  v-model="newGroup.groupEmailId"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <group-members-form
      @select-user="saveUser($event)"
      @remove-user="removeUser($event)"
      :refreshGroups="refreshGroups"
      ref="groupMembersForm"
    />
    <div class="button-wrapper">
      <button
        class="button button-secondary button-long"
        @click="$router.go(-1)"
      >
        Cancel
      </button>
      <button
        class="button button-primary button-long"
        @click="createGroup"
        :disabled="isButtonDisabled"
      >
        <button-loader v-if="isCreatingGroup" />
        <span v-else>Create Group</span>
      </button>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/PageHeader";
import GroupMembersForm from "./GroupMembersForm";
export default {
  components: {
    PageHeader,
    GroupMembersForm,
  },
  data() {
    return {
      newGroup: {
        groupName: "",
        groupDescription: "",
        groupType: "",
        groupEmailId: "",
        groupgroupusers: [],
      },
      isCreatingGroup: false,
      groupTypes: ["functional", "management", "project"],
      refreshGroups: false,
    };
  },
  computed: {
    isButtonDisabled() {
      return this.shouldDisableButton(this.newGroup);
    },
  },
  methods: {
    async createGroup() {
      this.isCreatingGroup = true;
      try {
        await this.$_createGroup(this.newGroup);
        this.onGroupCreated();
      } catch (error) {
        this.handleError(error);
        console.log(error);
        this.isCreatingGroup = false;
      }
    },
    onGroupCreated() {
      this.$store.dispatch("resetAllGroups");
      this.generateToast("Group has been successfully created!", "success");
      this.$router.push({ name: "UsersAndGroups" });
    },
    saveUser(user) {
      this.newGroup.groupgroupusers.push(user);
    },
    removeUser(userId) {
      let filteredUsers = this.newGroup.groupgroupusers.filter((user) => {
        return user.groupuserId != userId;
      });
      this.newGroup.groupgroupusers = filteredUsers;
    },
  },
};
</script>

<style scoped>
.form-header {
  margin: 2rem 0 1rem;
}
.input {
  margin-bottom: 1rem;
}
hr {
  width: 60%;
  margin: 1.5rem auto;
}
</style>
